import React from 'react';
import styles from './Documents.module.css';
import documentImage from '../../../src/img/otchet-avansoviy.jpg';

const Documents = () => {
  const documentsList = [
    'Кассовый чек с QR кодом',
    'Фирменный бланк (Форма 3Г)',
    'Свидетельства о регистрации ЮЛ (копия)',
    'Справка о постановке ЮЛ на учет в налоговой инспекции (копия)',
    'Прайс лист гостиницы на бланке',
    'Счет фактура (УПД)'
  ];

  const scrollToExamples = () => {
    const element = document.getElementById('examples');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="documents" className={`section ${styles.documents}`}>
      <div className="container">
        <div className={styles.documentsContent}>
          <div className={styles.documentsInfo}>
            <h2 className={styles.sectionTitle}>Какие отчетные документы мы оформляем?</h2>
            <h3 className={styles.sectionSubtitle}>
              Заказывая гостиничные чеки, клиент получает полный пакет документов, необходимый для отчета в бухгалтерии:
            </h3>
            <div className={styles.documentsList}>
              {documentsList.map((doc, index) => (
                <div key={index} className={styles.documentItem}>
                  <span className={styles.checkmark}>✅</span>
                  <span>{doc}</span>
                </div>
              ))}
            </div>
            <button className={styles.examplesButton} onClick={scrollToExamples}>
              Посмотреть примеры чеков
            </button>
          </div>
          <div className={styles.documentsImage}>
            <img 
              src={documentImage} 
              alt="Официальная страница для заказа командировочных документов" 
              className={styles.image}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Documents;